<template>
    <div class="marketing-attributes-revision-diff-modal__tab-item">
        <CompassTable size="medium">
            <CompassTableBody>
                <CompassTableRow
                    v-for="attribute in attributes"
                    :key="`marketing-attributes-revision-diff-modal__tab-item-${attribute.id}`"
                >
                    <CompassTableBodyCell
                        class="marketing-attributes-revision-diff-modal__tab-item-label"
                    >
                        <span class="typographies-paragraph-medium-semibold">
                            {{ attribute.label }}
                        </span>
                    </CompassTableBodyCell>

                    <CompassTableBodyCell
                        class="marketing-attributes-revision-diff-modal__tab-item-categories"
                    >
                        <span class="typographies-paragraph-medium-regular">
                            {{ attribute.category ? attribute.category.label : '' }}
                        </span>
                    </CompassTableBodyCell>
                </CompassTableRow>
            </CompassTableBody>
        </CompassTable>
    </div>
</template>

<script>
export default {
    props: {
        attributes: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.marketing-attributes-revision-diff-modal {
    &__tab {
        &-item {
            &:deep(.compass-table) {
                border-width: 0;

                .compass-table-body__row {
                    .compass-table-body__cell {
                        border-bottom-width: 0;
                    }

                    &:nth-child(odd) {
                        .compass-table-body__cell,
                        .compass-table-body__cell:hover {
                            background-color: var(--colors-common-background-subtle);
                        }
                    }

                    &:nth-child(even) {
                        .compass-table-body__cell,
                        .compass-table-body__cell:hover {
                            background-color: var(--colors-common-background-default);
                        }
                    }
                }
            }

            &-label,
            &-categories {
                width: 50%;
            }
        }
    }
}
</style>
